import { BaseEntity } from '../base-entity';


export class HtmlTemplate extends BaseEntity {
  public name: string;
  public documentName: string;

  public html: string;
  public previewHtml: string;
  public mjml: string;

  // English
  public htmlEn: string;
  public previewHtmlEn: string;
  public mjmlEn: string;

  // Spanish
  public htmlEs: string;
  public previewHtmlEs: string;
  public mjmlEs: string;

  // Italian
  public htmlIt: string;
  public previewHtmlIt: string;
  public mjmlIt: string;

  // French
  public htmlFr: string;
  public previewHtmlFr: string;
  public mjmlFr: string;
}

export class PushNotificationTemplate extends BaseEntity {
  createDate: Date;
  name: string;

  // German
  bodyTitleDe: string;
  bodyTextDe: string;
  notificationTitleDe: string;
  notificationTextDe: string;
  actionLabelDe: string;

  // English
  bodyTitleEn: string;
  bodyTextEn: string;
  notificationTitleEn: string;
  notificationTextEn: string;
  actionLabelEn: string;

  // Spanish
  bodyTitleEs: string;
  bodyTextEs: string;
  notificationTitleEs: string;
  notificationTextEs: string;
  actionLabelEs: string;

  // Italian
  bodyTitleIt: string;
  bodyTextIt: string;
  notificationTitleIt: string;
  notificationTextIt: string;
  actionLabelIt: string;

  // French
  bodyTitleFr: string;
  bodyTextFr: string;
  notificationTitleFr: string;
  notificationTextFr: string;
  actionLabelFr: string;

  data: { [key: string]: string };
  action: string;
  actionParameter: string | null;

  constructor() {
    super();
    this.createDate = new Date();
    this.name = "";

    // German
    this.bodyTitleDe = "";
    this.bodyTextDe = "";
    this.notificationTitleDe = "";
    this.notificationTextDe = "";
    this.actionLabelDe = "";

    // English
    this.bodyTitleEn = "";
    this.bodyTextEn = "";
    this.notificationTitleEn = "";
    this.notificationTextEn = "";
    this.actionLabelEn = "";

    // Spanish
    this.bodyTitleEs = "";
    this.bodyTextEs = "";
    this.notificationTitleEs = "";
    this.notificationTextEs = "";
    this.actionLabelEs = "";

    // Italian
    this.bodyTitleIt = "";
    this.bodyTextIt = "";
    this.notificationTitleIt = "";
    this.notificationTextIt = "";
    this.actionLabelIt = "";

    // French
    this.bodyTitleFr = "";
    this.bodyTextFr = "";
    this.notificationTitleFr = "";
    this.notificationTextFr = "";
    this.actionLabelFr = "";

    this.action = "";
    this.data = {};
    this.actionParameter = null;
  }
}
